export const GET_RESPONSES_LOADING = "GET_RESPONSES_LOADING";
export const GET_RESPONSES_SUCCESS = "GET_RESPONSES_SUCCESS";
export const GET_RESPONSES_FAILURE = "GET_RESPONSES_FAILURE";

export const GET_RESPONSES_RESET = "GET_RESPONSES_RESET";
